import { AnimatedSection } from "./AnimatedSection";

const CHAPTERS = [
  {
    n: "01",
    title: "Core Operations",
    body: "Ranjith Kumar handles our core accounting operations, field duties, and Tally reporting to ensure your financial tracking is meticulously maintained.",
  },
  {
    n: "02",
    title: "Auditing & Legal Expertise",
    body: "We coordinate with specialized professionals, including Mr. Neeraj (Auditor) and Mr. Ramesh (Advocate), to manage complex statutory audits and legal cases on a per-service basis.",
  },
  {
    n: "03",
    title: "Dedicated Administration",
    body: "Ms. Varalakshmi oversees our office administration, manages client relations, and assists with tax returns and audit preparations so you always receive timely support.",
  },
];

const FOUNDER_IMG =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_simple-accounts-team/artifacts/grmf0zwg_GrowHigh-Ranjith.jpeg";

export const Trust = () => (
  <section id="about" className="bg-[#0A1128] py-24 md:py-32 relative overflow-hidden">
    <div className="grain-overlay" />
    <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
      <div className="grid lg:grid-cols-12 gap-16">
        <AnimatedSection className="lg:col-span-5">
          <p className="overline text-[#C5A059] mb-4">Who We Are</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-white mb-6 leading-tight">
            Good advice. Reliable execution. No corporate jargon.
          </h2>
          <p className="text-slate-300 leading-relaxed mb-8">
            We know accounting and tax laws can be stressful. We started Grow High Accounting to
            take that burden off the shoulders of business owners.
          </p>
          <div className="rounded-2xl overflow-hidden border border-white/10 aspect-[4/5]">
            <img src={FOUNDER_IMG} alt="Ranjith Kumar, Accounting and Audit Expert at Grow High Chennai" className="w-full h-full object-cover" data-testid="founder-image" />
          </div>
        </AnimatedSection>

        <div className="lg:col-span-7 space-y-12">
          {CHAPTERS.map((c, i) => (
            <AnimatedSection
              key={c.n}
              delay={i * 0.15}
              data-testid={`manifesto-chapter-${c.n}`}
              className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 border-t border-white/10 pt-8"
            >
              <span className="font-serif text-5xl md:text-6xl text-[#C5A059] font-light">{c.n}</span>
              <div>
                <h3 className="font-serif text-2xl text-white mb-3">{c.title}</h3>
                <p className="text-slate-300 leading-relaxed text-base md:text-lg">{c.body}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </div>
  </section>
);
